webpackJsonp([17570309017519],{

/***/ 1028:
/***/ (function(module, exports) {

	module.exports = {"data":{"cardsJson":{"starting_zone":"codex","mid_text_1":null,"sirlins_filename":"0024_huntress.jpg","type":"Unit","subtype":"Centaur","cost":2,"ATK":3,"HP":3,"rules_text_1":"Sparkshot (When attacking a patroller, deals 1 damage to an adjacent patroller.)","rules_text_2":"Anti-air (Can attack fliers, but can ignore patrolling fliers. Deals combat damage to fliers it fights or that fly over this while it patrols.)","rules_text_3":null,"base_text_1":null,"base_text_2":null,"ATK_1":null,"HP_1":null,"mid_level":null,"name":"Huntress","mid_text_2":null,"ATK_2":null,"HP_2":null,"max_level":null,"max_text_1":null,"max_text_2":null,"ATK_3":null,"HP_3":null,"flavor_text":null,"color":"Green","spec":"Feral","bottom":"Tech I","rulings":[],"keywords":["Sparkshot","Anti-air"],"slug":"huntress"},"site":{"siteMetadata":{"title":"Codex Card Database"}}},"pathContext":{"slug":"huntress","keywords":["Sparkshot","Anti-air"],"imageRegex":"/huntress.jpg/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---card-huntress-abd7017fa8d393d75b71.js